import Job from "../../../model/job/Job";
import JobEvent from "../../../model/job/event/JobEvent";
import {Option} from "ts-option";
import {JobsMap} from "../../reducer/job/JobState";

/**
 * Create job successful action.
 */
export const JOB_CREATED = "JOB_CREATED";
export type JOB_CREATED = { job: Job };

/**
 * Update job successful action.
 */
export const JOB_UPDATED = "JOB_UPDATED";
export type JOB_UPDATED = { job: Job };

/**
 * Single job fetched action.
 */
export const JOB_FETCHED = "JOB_FETCHED";
export type JOB_FETCHED = { job: Job };

/**
 * Update job status successful action.
 */
export const JOB_STATUS_UPDATED = "JOB_STATUS_UPDATED";
export type JOB_STATUS_UPDATED = { jobId: string, statusId: string };

/**
 * Job events fetched action.
 */
export const JOB_EVENTS_FETCHED = "JOB_EVENTS_FETCHED";
export type JOB_EVENTS_FETCHED = { jobId: string, events: Array<JobEvent> }

/**
 * Job agent assignee updated action.
 */
export const JOB_AGENT_UPDATED = "JOB_AGENT_UPDATED";
export type JOB_AGENT_UPDATED = { jobId: string, agentId: Option<string> };

/**
 * Job watchers updated action.
 */
export const JOB_WATCHERS_UPDATED = "JOB_WATCHERS_UPDATED";
export type JOB_WATCHERS_UPDATED = { jobId: string, watchers: string[] };